import useCaseList from "../../features/cases/useCaseList";
import CaseListDesktop from "../cases/CaseListDesktop";
import { POINIKA_CONFIG } from "./poinikaConfig";

const LIST = { endpoint: "/poinpin", pollMs: 30000 };

const PoinikaDesktop = () => (
  <CaseListDesktop config={POINIKA_CONFIG} list={useCaseList(LIST)} />
);

export default PoinikaDesktop;
